// US states used for "browse by state" internal links (/best-golf-courses/:state)
export const STATES = [
  { slug: "alabama", label: "Alabama" },
  { slug: "alaska", label: "Alaska" },
  { slug: "arizona", label: "Arizona" },
  { slug: "arkansas", label: "Arkansas" },
  { slug: "california", label: "California" },
  { slug: "colorado", label: "Colorado" },
  { slug: "connecticut", label: "Connecticut" },
  { slug: "delaware", label: "Delaware" },
  { slug: "florida", label: "Florida" },
  { slug: "georgia", label: "Georgia" },
  { slug: "hawaii", label: "Hawaii" },
  { slug: "idaho", label: "Idaho" },
  { slug: "illinois", label: "Illinois" },
  { slug: "indiana", label: "Indiana" },
  { slug: "iowa", label: "Iowa" },
  { slug: "kansas", label: "Kansas" },
  { slug: "kentucky", label: "Kentucky" },
  { slug: "louisiana", label: "Louisiana" },
  { slug: "maine", label: "Maine" },
  { slug: "maryland", label: "Maryland" },
  { slug: "massachusetts", label: "Massachusetts" },
  { slug: "michigan", label: "Michigan" },
  { slug: "minnesota", label: "Minnesota" },
  { slug: "mississippi", label: "Mississippi" },
  { slug: "missouri", label: "Missouri" },
  { slug: "montana", label: "Montana" },
  { slug: "nebraska", label: "Nebraska" },
  { slug: "nevada", label: "Nevada" },
  { slug: "new-hampshire", label: "New Hampshire" },
  { slug: "new-jersey", label: "New Jersey" },
  { slug: "new-mexico", label: "New Mexico" },
  { slug: "new-york", label: "New York" },
  { slug: "north-carolina", label: "North Carolina" },
  { slug: "north-dakota", label: "North Dakota" },
  { slug: "ohio", label: "Ohio" },
  { slug: "oklahoma", label: "Oklahoma" },
  { slug: "oregon", label: "Oregon" },
  { slug: "pennsylvania", label: "Pennsylvania" },
  { slug: "rhode-island", label: "Rhode Island" },
  { slug: "south-carolina", label: "South Carolina" },
  { slug: "south-dakota", label: "South Dakota" },
  { slug: "tennessee", label: "Tennessee" },
  { slug: "texas", label: "Texas" },
  { slug: "utah", label: "Utah" },
  { slug: "vermont", label: "Vermont" },
  { slug: "virginia", label: "Virginia" },
  { slug: "washington", label: "Washington" },
  { slug: "west-virginia", label: "West Virginia" },
  { slug: "wisconsin", label: "Wisconsin" },
  { slug: "wyoming", label: "Wyoming" },
];
